import { useMutation } from "@tanstack/react-query";
import { Link, useNavigate, useSearch } from "@tanstack/react-router";
import { useEffect, useRef, type ReactElement } from "react";
import type { LogisticsIntegrationView } from "@cx/contracts";
import { ContentHeader, useToast } from "@cx/ui";
import { errorMessage } from "../../errors";
import { useSession } from "../../session";

/**
 * Volta da autorização do Melhor Envio (T3.4): posta `code` e `state` uma vez só. O servidor confere o state (sessão,
 * empresa, validade), troca o code pelos tokens (cifrados) e grava a integração; repetir devolve a mesma.
 */
export function MelhorEnvioCallbackPage(): ReactElement {
  const { api } = useSession();
  const { code, state, error } = useSearch({ from: "/integracoes/logistica/melhor-envio/retorno" });
  const navigate = useNavigate();
  const toast = useToast();
  const sent = useRef(false);
  const finish = useMutation({
    mutationFn: () =>
      api<LogisticsIntegrationView>("/logistics/integrations/melhorenvio/callback", {
        method: "POST",
        body: JSON.stringify({ code, state }),
      }),
    onSuccess: (i) => {
      toast("success", `${i.name} conectado`);
      void navigate({ to: "/preferencias/integracoes/logistica", replace: true });
    },
  });
  const ok = !!code && !!state && !error;
  useEffect(() => {
    if (!ok || sent.current) return;
    sent.current = true;
    finish.mutate();
  }, [ok, finish]);
  return (
    <>
      <ContentHeader
        title="Conectando o Melhor Envio"
        breadcrumb={["Preferências", "Integrações", "Logística", "Melhor Envio"]}
      />
      <div className="box card p-3">
        {!ok && (
          <p className="mb-2">
            {error ? "A autorização foi recusada no Melhor Envio." : "Retorno do Melhor Envio incompleto."}
          </p>
        )}
        {ok && finish.isPending && <p className="mb-0">Concluindo a conexão…</p>}
        {finish.isError && <div className="alert alert-danger py-2">{errorMessage(finish.error)}</div>}
        {(!ok || finish.isError) && (
          <Link to="/preferencias/integracoes/logistica">Voltar para a logística</Link>
        )}
      </div>
    </>
  );
}
